// extracted by mini-css-extract-plugin
export var menuItem = "L_wF d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "L_wG d_Z d_bz d_bP";
export var menuMainLink = "L_wH d_f0 d_dB";
export var menuLink = "L_wJ d_f0 d_dB";
export var icon = "L_n9 d_bC d_bP";
export var divider = "L_wK d_bC d_bP";
export var sublinks = "L_wL";
export var link = "L_mC";
export var Link = "L_vg z_vg z_tB z_tW";